interface FooterLegalProps {
  paragraphClassName?: string;
  trecLinkClassName?: string;
  splitCopyright?: boolean;
  copyrightClassName?: string;
}

export const FooterLegal = ({
  paragraphClassName,
  trecLinkClassName,
  splitCopyright,
  copyrightClassName,
}: FooterLegalProps = {}) => (
  <>
    <div
      className={
        paragraphClassName ??
        'text-xs text-footer leading-5.5 space-y-6 py-1.5 text-justify [text-align-last:center]'
      }
    >
      <p>
        KKI Ventures, Inc, a California Corporation (&lsquo;KKI&rsquo;) is in the business of real
        estate brokerage, real estate property management and real estate mortgage brokering. KKI
        has registered the following fictitious business names and is operating under the following
        license numbers: KKI Fictitious Business Names: Marshall Reddick | Marshall Reddick Real
        Estate | Marshall Reddick Property Management | Marshall Reddick Private Lending. KKI is
        operating under the following license numbers: CA DRE: 01904891 | FL: CQ1060671 | KY: 244698
        | TN: 264002 | TX: 9006577
      </p>
      <p>
        Marshall Reddick Mortgage Fund, LLC, a California Limited Liability Company
        (&lsquo;MRMF&rsquo;) is in the business of funding non-owner occupied, real estate secured,
        business purpose loans and is managed by KKI. MRMF has registered no fictitious business
        names and is operating under the following license numbers: CA CFL: 60DBO-184902 | NMLS:
        2287953
      </p>
    </div>

    <div className="py-4 text-xs text-footer">
      <a
        href="/assets/downloads/trec-consumer-protection-notice.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className={
          trecLinkClassName ??
          'text-footer hover:text-footer-text-hover whitespace-nowrap underline'
        }
      >
        TREC Consumer Protection Notice
      </a>
      {!trecLinkClassName && ' | '}
      <a
        href="/assets/downloads/trec-information-brokerage-services.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className={
          trecLinkClassName ??
          'text-footer hover:text-footer-text-hover whitespace-nowrap underline'
        }
      >
        TREC Information About Brokerage Services
      </a>
    </div>

    <div className={copyrightClassName ?? 'py-2 text-xs text-footer'}>
      {splitCopyright ? (
        <>
          <div>
            Copyright (c) {new Date().getFullYear()} KKI Ventures, Inc, a California Corporation,
            DBA: Marshall Reddick Real Estate
          </div>
          <div>All Rights Reserved</div>
        </>
      ) : (
        <>
          Copyright (c) {new Date().getFullYear()} KKI Ventures, Inc, a California Corporation, DBA:
          Marshall Reddick Real Estate - All Rights Reserved
        </>
      )}
    </div>
  </>
);
